import { reaction } from 'mobx';
import { iocContainer, TYPES } from '@/engine/ioc';
import { type PlanningAlgorithm } from '../PlanningAlgorithm/PlanningAlgorithm';
import { type ISugerySaveStateUpdateSubscriber } from './interfaces';
import { type ViewsService } from './Views.service';

export class DefaultSaveStateUpdateSubscriber implements ISugerySaveStateUpdateSubscriber {
  private readonly _viewsService: ViewsService;

  private readonly _planningAlgorithm: PlanningAlgorithm;

  public constructor() {
    this._viewsService = iocContainer.get<ViewsService>(TYPES.ViewsService);
    this._planningAlgorithm = iocContainer.get<PlanningAlgorithm>(TYPES.PlanningAlgorithm);
  }

  public initSubcriptions(callback: () => void): void {
    this._viewsService.views.forEach((view) => {
      reaction(
        () => view.getObjects().slice(),
        (/*viewModels*/) => {
          callback();
        }
      );

      reaction(
        () => view.getMeasurements().slice(),
        (/*viewModels*/) => {
          callback();
        }
      );

      reaction(
        () =>
          view
            .getMeasurements()
            .slice()
            .map((vm) => vm.label),
        (/*labels*/) => {
          callback();
        }
      );

      reaction(
        () => view.getOrientationPresets().slice(),
        (/*viewModels*/) => {
          callback();
        }
      );

      reaction(
        () =>
          view
            .getOrientationPresets()
            .slice()
            .map((preset) => preset.label),
        (/*labels*/) => {
          callback();
        }
      );
    });

    this._planningAlgorithm.addOnChangedCallback(() => {
      callback();
    });
  }
}
